import React, { useState } from "react";
import "./Navbar.css";
import notification from "../../image/notifition.png";
import profile from "../../image/profile.png";
import dropDown from "../../image/dropDown.png";
import menuIcon from "../../image/menu-icon.png";
import search from "../../image/search.png";
import { Link } from "react-router-dom";
import SideBar from "../SideBar/SideBar";


const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const handaleToggle = () => {
    setToggle(!toggle);
  };
  return (
    <div className="container-fluid">
      <div className="top_part">
        <div className="mobile_menu" onClick={handaleToggle}>
          <img src={menuIcon} alt="menu icon"/>
          <SideBar toggle={toggle} />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
